import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { MenuPage } from './pages/MenuPage';
import { CateringPage } from './pages/CateringPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/about" element={<AboutPage data-id="element-6" />} data-id="element-5" />
          <Route path="/menu" element={<MenuPage data-id="element-8" />} data-id="element-7" />
          <Route path="/catering" element={<CateringPage data-id="element-10" />} data-id="element-9" />
          <Route path="/contact" element={<ContactPage data-id="element-12" />} data-id="element-11" />
        </Routes>
      </Layout>
    </Router>;
}